import React, { useMemo } from 'react';
import {
  Box,
  HStack,
  Popover,
  PopoverArrow, PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger, Text,
  VStack
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { get, set } from '../../../../../utils/arrayUtil';

const RequirementsCell = ({ value: { data: itemsOrInsureds } }) => {
  const policyNameMap = {};
  const propertyNameMap = {};

  const maxRequirements = useMemo(() => itemsOrInsureds.reduce((maxValues, itemOrInsured) => {
    get(itemOrInsured, 'insuranceRequirement.properties', [], false, false).forEach(property => {
      const value = Number(property.value);
      const valuePath = `${property.policyType.name}.${property.name}.value`;
      const dataTypePath = `${property.policyType.name}.${property.name}.dataType`;
      const previousMax = get(maxValues, valuePath);

      policyNameMap[property.policyType.name] = property.policyType.displayName;
      propertyNameMap[property.name] = property.displayName;

      if (!previousMax) {
        set(maxValues, valuePath, value);
        set(maxValues, dataTypePath, property.dataType);
      }

      if (previousMax && previousMax < value) set(maxValues, valuePath, value);
    });

    return maxValues;
  }, {}), [itemsOrInsureds, policyNameMap, propertyNameMap]);

  if (!Object.keys(maxRequirements).length) {
    return (
      <Text fontWeight="medium">
        No Requirements
      </Text>
    );
  }

  return (
    <Popover
      placement="bottom"
      trigger="hover"
    >
      <PopoverTrigger>
        <Text color="primaryScale.500" cursor="pointer" fontWeight="medium">
          View Requirements
        </Text>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody mt={3} mx={2}>
          <VStack justifyContent="space-between" spacing={2}>
            {
              Object.entries(maxRequirements).map(([policyTypeName, maxProperties]) => (
                <VStack alignItems="flex-start" key={policyTypeName} w="100%">
                  <Box
                    borderRadius="md"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    {policyNameMap[policyTypeName]}
                  </Box>
                  {
                    Object.entries(maxProperties).map(([propertyName, { value, dataType }]) => (
                      <HStack key={propertyName}>
                        <Box fontSize="sm" textTransform="capitalize">{propertyNameMap[propertyName]}</Box>
                        <Box color="greyScale.500" fontSize="sm">
                          {dataType === 'monetary' ? '$' : ''}
                          {dataType === 'monetary' ? value.toLocaleString() : Number(value) ? 'On' : 'Off'}
                        </Box>
                      </HStack>
                    ))
                    }
                </VStack>
              ))
            }
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

RequirementsCell.propTypes = { value: PropTypes.shape({ data: PropTypes.array }) };

export default RequirementsCell;
